import classNames from 'classnames';

import {
  getTabTestId,
  ROUNDED_TAB_BLACK_VARIANT,
  ROUNDED_TAB_GREY_VARIANT,
  ROUNDED_TAB_WHITE_VARIANT,
  RoundedTabsProps,
} from '../tabs.type';

export const RoundedTabs = ({ tabs, onChange, activeTab, variant }: RoundedTabsProps) => {
  return tabs.map((tab) => (
    <button
      key={tab.name}
      type='button'
      data-testid={getTabTestId(tab.id)}
      className={classNames(
        'whitespace-nowrap py-1.5 px-3 xs:py-2 xs:px-4 rounded-full justify-start items-center text-subtitle-s',
        {
          'bg-transparent text-tertiary': tab.id !== activeTab,
          'fill-dark text-negative': tab.id === activeTab && variant === ROUNDED_TAB_BLACK_VARIANT,
          'hover:fill-dark hover:text-negative': tab.id !== activeTab && variant === ROUNDED_TAB_BLACK_VARIANT,
          'fill-tertiary text-primary': tab.id === activeTab && variant === ROUNDED_TAB_GREY_VARIANT,
          'hover:fill-tertiary hover:text-primary': tab.id !== activeTab && variant === ROUNDED_TAB_GREY_VARIANT,
          'fill-primary border-hard border text-primary': tab.id === activeTab && variant === ROUNDED_TAB_WHITE_VARIANT,
          'border-transparent border hover:border-soft-hover hover:text-secondary':
            tab.id !== activeTab && variant === ROUNDED_TAB_WHITE_VARIANT,
        }
      )}
      onClick={() => onChange(tab.id)}>
      {tab.name}
    </button>
  ));
};
